import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { toggleTheme, toggleSearch } from '../features/uiSlice';
import { logout } from '../features/authSlice';
import { authAPI } from '../services/authApi';
import styles from '../css/Header.module.css';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useSelector((state) => state.ui.theme);
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    try {
      await authAPI.logout();
    } catch {
      // Игнорируем ошибки сети — всё равно разлогиниваем локально
    }
    dispatch(logout());
    navigate('/');
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <Link to="/" className={styles.logo}>DoramaHype</Link>

        <nav className={styles.navMain}>
          <NavLink to="/" className={({ isActive }) => isActive ? styles.active : ''}>
            Главная
          </NavLink>
          <NavLink to="/catalog" className={({ isActive }) => isActive ? styles.active : ''}>
            Каталог
          </NavLink>
          <NavLink
            to="/bookmarks"
            className={({ isActive }) => isActive ? styles.active : ''}
          >
            Мое
          </NavLink>
          <div className={styles.dropdown}>
            <div className={styles.dropdownToggle}>Еще</div>
            <div className={styles.dropdownMenu}>
              <Link to="/top-100">Топ 100</Link>
              <Link to="/new">Новинки 2026</Link>
              <Link to="/ongoing">Онгоинг</Link>
              <Link to="/lakorns">Лакорны</Link>
              <Link to="/history">История просмотров</Link>
              <Link to="/bookmarks">Закладки</Link>
            </div>
          </div>
        </nav>

        <div className={styles.headerActions}>
          <button
            className={styles.searchTrigger}
            aria-label="Поиск"
            onClick={() => dispatch(toggleSearch())}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>

          <button
            className={`${styles.themeToggle} ${styles.desktopOnly}`}
            aria-label="Переключить тему"
            onClick={() => dispatch(toggleTheme())}
          >
            {theme === 'light' ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>

          {isAuthenticated ? (
            <div className={`${styles.userDropdownWrap} ${styles.desktopOnly}`}>
            <div className={styles.dropdown}>
              <div className={styles.userMenuToggle}>
                {user?.avatar_url ? (
                  <img src={user.avatar_url} alt="Аватар" className={styles.userAvatar} />
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                )}
              </div>
              <div className={styles.dropdownMenu}>
                <Link to="/profile">Профиль</Link>
                <Link to="/settings">Настройки</Link>
                <button onClick={handleLogout} className={styles.logoutButton}>
                  Выйти
                </button>
              </div>
            </div>
            </div>
          ) : (
            <Link
              to="/auth/login"
              className={`${styles.userIcon} ${styles.desktopOnly}`}
              aria-label="Войти"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
